import { createSelector } from "@reduxjs/toolkit";

import { latestDeploymentActivityKey } from "./latestDeploymentActivity.slice";

import type { LatestDeploymentActivityParams } from "./latestDeploymentActivity.slice";
import type { RootState } from "Store/configureStore";

const latestDeploymentActivityState = (state: RootState) =>
  state.latestDeploymentActivity;

export const selectLatestDeploymentActivity = createSelector(
  latestDeploymentActivityState,
  (_: RootState, params: LatestDeploymentActivityParams) => params,
  (state, params) => state.byEnvironment[latestDeploymentActivityKey(params)]
);

/**
 * Whether this activity is the environment's current deployment — the recency
 * half of the Troubleshoot gate.
 *
 * Three-valued on purpose. `undefined` means the answer has not arrived, and the
 * caller must render nothing rather than guess: guessing `true` flashes a CTA
 * that then vanishes, and guessing `false` is indistinguishable from a real
 * "no", which would hide the button on a slow network.
 */
export const selectIsLatestDeploymentActivity = createSelector(
  selectLatestDeploymentActivity,
  (
    _: RootState,
    params: LatestDeploymentActivityParams & { activityId: string }
  ) => params.activityId,
  (entry, activityId) => {
    if (!entry?.hasLoaded) return undefined;
    return entry.activityId === activityId;
  }
);
